import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/budget-tracking",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "budget-tracking-page",
        component: () => import("@/views/BudgetTracking/BudgetTrackingPage.vue"),
        meta: {
          title: "Capex",
          titleLocalizationCode: "Budget_Tracking",
          desc: "Capex page",
          descLocalizationCode: "Budget_Tracking_Page",
          sidebarElement: false,
          permissionCodes: [
            "BudgetTracking.Read",
            "BudgetTracking.Add",
            "BudgetTracking.Edit",
            "BudgetTracking.Delete",
          ],
        },
      },
    ],
  },
];
